import type { VoidFunctionComponent } from 'react';

import type { Tool } from '../../../shared/techStack';
import List from '../generic/List';

import styles from './ToolsTable.module.less';

export type Props = {
  tools: Tool[];
  isLoading: boolean;
  isError: boolean;
};

/**
 * ToolsTable component displays a list of tools with their details.
 */
const ToolsTable: VoidFunctionComponent<Props> = ({ tools, isLoading, isError }) => {
  return (
    <List>
      <div className={styles.tableHeaderRow}>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Tool</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Category</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Subcategory</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>End of Life</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Projects</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Teams</List.HeaderText></span>
        <span className={styles.tableHeaderColumn}><List.HeaderText>Versions</List.HeaderText></span>
      </div>
      <List.Body>
        {/* TODO(CORE-5236): Add fallback state for loading */}
        {isLoading && <p>Loading...</p>}
        {/* TODO(CORE-5237): Add fallback state for errors */}
        {isError && <p>Error loading tools</p>}
        {/* TODO(CORE-5238): Add fallback state for empty results */}
        {tools.length === 0 && <p>No tools found</p>}

        {tools.map((tool) => (
          <div key={tool.id} className={styles.tableBodyRow}>
            <span className={styles.tableBodyColumn}>
              {/* TODO(CORE-5146): Add a logo for each tool */}
              {tool.name}
            </span>
            <span className={styles.tableBodyColumn}>{tool.category}</span>
            <span className={styles.tableBodyColumn}>{tool.subcategory}</span>
            <span className={styles.tableBodyColumn}>{tool.unsupportedCount}</span>
            <span className={styles.tableBodyColumn}>{tool.projectCount}</span>
            <span className={styles.tableBodyColumn}>{tool.teamCount}</span>
            <span className={styles.tableBodyColumn}>{tool.versionCount ?? 'n/a'}</span>
          </div>
        ))}
      </List.Body>
    </List>
  );
};

export default ToolsTable;
